import styled from 'styled-components'

export const CenterDataGridCell = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 0; // needed for a flex container to constrain the width of the children so text-overflow can work
  height: 100%;
`
